import { useState, useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Cards from "./routes/cards/Cards";
import Favorites from "./routes/favorites/Favorites";
import Home from "./routes/home/Home";
import { Calendarr } from "./routes/calendar/Calendarr";
import Recipe from "./routes/recipe/Recipe";
import Menu from "./routes/menu/Menu";
import AddCard from "./routes/addCard/AddCard";
import LoginOnboarding from "./routes/loginOnboarding/LoginOnboarding";
import Login from "./routes/login/Login";
import TutorialWhy from "./routes/tutorialWhy/tutorial-why";
import TutorialHow from "./routes/tutorialHow/tutorial-how";
import Subscription from "./routes/subscription/Subscription";
import Tag from "./routes/tags/Tag";
import Search from "./routes/search/Search";
import PolicyPrivacy from "./routes/tutorials/PolicyPrivacy";
import VerifyPayment from "./routes/verifyPayment/verifyPayment";
import Account from "./routes/menu/components/Account";
import { ProtectedRoutes, LoginRoute } from "./components/ProtectedRoutes";
import LoadingPage from "./components/LoadingPage";
import Chat from "./components/Papercups";
import Grocery from "./routes/grocery/Grocery";
import Ninja from "./routes/ninja/Ninja";
import Diets from "./routes/diet/Diets";
import ChallengeDetails from "./routes/challenges/ChallengeDetails";
import Achievements from "./routes/achievements/Achievements";
import Community from "./routes/community/Community";
import Groups from "./routes/groups/Groups";
import GroupPage from "./routes/groups/GroupPage";
import GroupInvite from "./routes/groups/GroupInvite";
import AchievementUnlockWatcher from "./components/achievements/AchievementUnlockToast";

function App() {

  const [isLoading, setIsLoading] = useState(true);
  const isLoggedIn = !!localStorage.getItem("token");


  useEffect(() => {
    setIsLoading(true);
    // Simulate a delay to show the loading state
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [window.location.pathname]); // Watch for changes in the URL


  return (
    <>

      <div className="container">

        {isLoggedIn && <AchievementUnlockWatcher />}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={false}
          closeButton={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <>
        {/* <Chat></Chat> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cards" element={<Cards />} />
          <Route path="/grocery" element={<Grocery />} />
          <Route path="/calendar" element={<Calendarr />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/account" element={<Account />} />
          <Route path="/Search" element={<Search />} />
          <Route path="/community" element={<Community />} />
          <Route path="/group/invite/:token" element={<GroupInvite />} />

          <Route element={<ProtectedRoutes />}>
            <Route path="/verify" element={<VerifyPayment />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/tags/:id" element={<Tag />} />
            <Route path="/recipe/:id" element={<Recipe />} />
            <Route path="/ninja" element={<Ninja />} />
            <Route path="/diet" element={<Diets />} />
            <Route path="/challenges/:id" element={<ChallengeDetails />} />
            <Route path="/achievements" element={<Achievements />} />
            <Route path="/groups" element={<Groups />} />
            <Route path="/groups/:id" element={<GroupPage />} />
            {/* <Route path="/addCard" element={<AddCard />} /> */}

          </Route>

          <Route element={<LoginRoute />}>
            <Route path="/login" element={<Login />} />
          </Route>

          <Route path="/loginOnboarding" element={<LoginOnboarding />} />
          <Route path="/policyPrivacy" element={<PolicyPrivacy />} />
          <Route path="/tutorialWhy" element={<TutorialWhy />} />
          <Route path="/tutorialHow" element={<TutorialHow />} />
          <Route path="/subscription" element={<Subscription />} />
          
          {/* <Route path="/fl" element={<FavList />} /> */}
          {/* <Route path="/card-menu" element={<CardMenu />} /> */}
          {/* <Route path="/contactus" element={<ContactUs />} /> */}

        </Routes>
        </>
        
      </div>
    </>
    );
}

export default App;
